import Vue from 'vue';

import {
    Select

} from 'element-ui';

export const JtSelect = Vue.extend({
    extends: Select,
    methods: {
        setTagState(value, [ Node, data = {} ] =[]) {
            const targetSelected = this.selected.find(v=>v.value === value);
            if(!targetSelected) return;
            const text = targetSelected.currentLabel;
            const tags = this.$refs.tags;
            if (!tags) {
                return;
            };
            // document.createElement('div');
            const tagDoms = tags.querySelectorAll('.el-select__tags-text');
            const targetTag = ([].slice.call(tagDoms)).find(tag=> {
                return tag.textContent === text
            });
            if (!targetTag) {
                return;
            };

            const parentElement = targetTag.parentElement;
            parentElement.style.borderColor = 'red';
            const NodeConstructor =  Vue.extend(Node);
            const instance = new NodeConstructor({
                data
            });
            const id = `custom-${value}`;
            const hasCustom = tags.querySelector(`#${id}`)
            if (hasCustom) {
                hasCustom.remove();
            }
            instance.$mount();
            instance.$el.setAttribute('id', id);
            targetTag.after(instance.$el);
            this.$nextTick(() => {
                this.resetInputHeight();
            });
        },
        delAllTagState() {
            const tags = this.$refs.tags;
            const customDoms = tags.querySelectorAll('[id*="custom"]');
            if (!customDoms) {
                return;
            }
            ([].slice.call(customDoms)).forEach(dom=> {
                const parentElement =  dom.parentElement;
                parentElement.style.borderColor = '#e9e9eb';
                dom.remove();
            });
        },
        delTagState(value) {
            const id = `custom-${value}`;
            const tags = this.$refs.tags;
            const hasCustom = tags.querySelector(`#${id}`);
            if (!hasCustom) {
                return;
            }else {
                const parentElement =  hasCustom.parentElement;
                parentElement.style.borderColor = '#e9e9eb';
                hasCustom.remove();
            };
        }
    }
})
